var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progressBox",style:('background:'+_vm.bgColor)},[_c('div',{style:('background:'+_vm.color+';width:'+_vm.percent+'%')},[_c('span',{style:(Number(_vm.percent)<50?'right:-40px':'right:0px')},[_vm._v(_vm._s(_vm.percent)+"%")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }